<template>

  <a @click="playPlaylist" class="table-icon tooltip" data-tooltip="Play Playlist">
    <IconPlay/>
  </a>
</template>

<script>
import { IconPlay } from '@/Icons/IconBase'
import { AUDIO_PLAYER_LOAD, QUEUED_AUDIO_FILE_SESSION_ALL, QUEUED_AUDIO_FILE_SESSION_CREATE_BY_PLAYLIST, QUEUED_AUDIO_FILE_SESSION_UPDATE } from '@/store/actions'
import moment from 'moment'

export default {
  name: 'PlayPlaylistButton',
  props: ['playlistId'],
  components: {
    IconPlay
  },
  methods: {
    playPlaylist() {
      let self = this
      let sessionId = this.$store.getters.getSessionId
      this.$store.dispatch(QUEUED_AUDIO_FILE_SESSION_CREATE_BY_PLAYLIST, {
        session_id: sessionId,
        playlist_id: this.playlistId,
        overwrite: true
      })
        .then(function () {
          self.playQueuedAudioFiles(sessionId)
        })
        .catch(function (err) {
          self.$store.commit('error', `Could not play playlist.`)
          console.log(err)
        })
    },

    playQueuedAudioFiles(sessionId) {
      let self = this
      this.$store.dispatch(QUEUED_AUDIO_FILE_SESSION_ALL, sessionId)
        .then(function (data) {
          if (data && data.length) {
            self.$store.dispatch(AUDIO_PLAYER_LOAD, { id: data[0].audio_file_id })
            self.$store.dispatch(QUEUED_AUDIO_FILE_SESSION_UPDATE, {
              id: data[0].id,
              data: {
                played_at: moment().utc().format('YYYY-MM-DD HH:mm:ss')
              }
            }).then(function () {
              self.$store.dispatch(QUEUED_AUDIO_FILE_SESSION_ALL, sessionId)
            })
          }
        }, function (err) {
          self.$store.commit('error', `Could not play playlist.`)
          console.log(err)
        })
    }
  }
}
</script>
